import React, { useState } from "react";
import { Button, Card, EmptyState, KeyValueList, Section } from "@sscs/ui";
import { filterByLink } from "../../../store/issuesSlice";
import { LinkToReportTab } from "../../common";
import { useReportDispatch } from "../../hooks";
import { useGetReportMappingsQuery } from "../../services/shared.api";
import styles from "./issuesList.module.scss";
const SHOW_MORE_LIMIT = 5;
const IssuesList = ({ violations, to, nested = false, className, }) => {
    const dispatch = useReportDispatch();
    const { data: reportMappings } = useGetReportMappingsQuery();
    const [showAll, setShowAll] = useState(false);
    const content = violations.length !== 0 ? (React.createElement(React.Fragment, null,
        React.createElement(KeyValueList, { list: [
                violations
                    .slice(0, showAll ? undefined : SHOW_MORE_LIMIT)
                    .map((policyId) => {
                    var _a;
                    return [
                        React.createElement(LinkToReportTab, { key: `${policyId}-link`, id: policyId, to: to, color: "link", className: styles.link, onClick: () => dispatch(filterByLink({
                                issue: { operation: "is", values: [policyId] },
                            })) }, policyId),
                        React.createElement(React.Fragment, { key: `${policyId}-description` }, (_a = reportMappings === null || reportMappings === void 0 ? void 0 : reportMappings.descriptions[policyId]) !== null && _a !== void 0 ? _a : "--"),
                    ];
                }),
            ] }),
        violations.length > SHOW_MORE_LIMIT ? (React.createElement(Button, { variant: "text", size: "small", onClick: () => setShowAll((prev) => !prev), className: styles["show-more"] },
            "Show ",
            showAll ? "less" : "more")) : null)) : (React.createElement(EmptyState, { subject: "issues" }));
    if (nested) {
        return (React.createElement(Section, { className: className },
            React.createElement(Section.Title, null, "Causes issues"),
            React.createElement(Section.Content, null, content)));
    }
    return (React.createElement(Card.Card, { className: className },
        React.createElement(Card.Title, null, "Causes issues"),
        React.createElement(Card.Content, null, content)));
};
export default IssuesList;
//# sourceMappingURL=IssuesList.js.map